import React from 'react';

export default function ProbabilityCards({ probabilities }) {
  const cards = [
    {
      key: 'fraud',
      icon: '🚨',
      title: 'Probabilidade de Fraude',
      desc: 'Chance de ser phishing, malware ou golpe',
      value: probabilities?.fraud || 0,
      className: 'fraud',
    },
    {
      key: 'falsePositive',
      icon: '⚡',
      title: 'Falso Positivo',
      desc: 'Chance de ser legítimo mas parecer suspeito',
      value: probabilities?.falsePositive || 0,
      className: 'false-positive',
    },
    {
      key: 'safe',
      icon: '✅',
      title: 'URL Confiável',
      desc: 'Chance de ser uma URL válida e segura',
      value: probabilities?.safe || 0,
      className: 'safe',
    },
  ];

  return (
    <div className="probability-cards">
      {cards.map((card) => (
        <div key={card.key} className="prob-card">
          <div className={`prob-icon ${card.className}`}>{card.icon}</div>
          <div className="prob-info">
            <div className="prob-title">{card.title}</div>
            <div className="prob-desc">{card.desc}</div>
          </div>
          <div className="prob-bar-container">
            <div className="prob-bar-bg">
              <div
                className={`prob-bar-fill ${card.className}`}
                style={{ width: `${card.value}%` }}
              />
            </div>
          </div>
          <div className={`prob-percent ${card.className}`}>{card.value}%</div>
        </div>
      ))}
    </div>
  );
}
